import { toast } from 'react-toastify';

import { isArray } from 'lodash';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';
import { closeDialog } from '~/store/modules/dialog/actions';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestLocalidade({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'localidades', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
    yield put(closeDialog());
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* deleteLocalidade({ payload }) {
  try {
    const { idlocalidade, params } = payload;

    yield call(api.delete, `localidades/${idlocalidade}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* store({ payload }) {
  try {
    const { localidade, params } = payload;

    yield call(api.post, 'localidades', localidade);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/localidades');
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* find({ payload }) {
  try {
    const { idlocalidade } = payload;

    const { data } = yield call(api.get, `localidades/${idlocalidade}`);
    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* update({ payload }) {
  try {
    const { idlocalidade, params } = payload;

    yield call(api.put, 'localidades', idlocalidade);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/localidades');
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'localidades', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export default all([
  takeLatest('@localidade/LOCALIDADES_IN_REQUEST', requestLocalidade),
  takeLatest('@localidade/DELETE_LOCALIDADE', deleteLocalidade),
  takeLatest('@localidade/SUCCESS_REMOVE', requestLocalidade),
  takeLatest('@localidade/STORE_LOCALIDADE', store),
  takeLatest('@localidade/FIND_LOCALIDADE', find),
  takeLatest('@localidade/UPDATE_LOCALIDADE', update),
  takeLatest('@localidade/RECORD_FILTERING', applyedFilters),
]);
